export default {
  install: (app) => {
    app.config.globalProperties.$scroll = {
      toElement(el) {
        let elContent = document.getElementById(el)
        elContent.scrollToPoint(0, elContent.offsetTop, 1000)
      },
      toTop(el) {
        let elContent = document.getElementById(el)
        elContent.scrollToTop(500)
      }
    }
  }
}
